import { useQuery, useQueryClient } from "@tanstack/vue-query";
import { watch, Ref, computed } from "vue";
import { ListListaOpcionesAction } from "../actions/ListListaOpcionesAction";

export function useListListaOpciones(nombreLista: Ref<string>) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ["ListListaOpciones", nombreLista],
    queryFn: () => ListListaOpcionesAction(nombreLista.value),
    enabled: !!nombreLista.value, // evita ejecutar si newNombre está vacío
    staleTime: 60 * 1000,
  });

  const opciones =  computed(() => query.data.value?.data?.data?.opciones || []);

  // Si cambia el nombre, hacer prefetch
  watch(nombreLista, (newNombre) => {
    if (newNombre) {
      queryClient.prefetchQuery({
        queryKey: ["ListListaOpciones", newNombre],
        queryFn: () => ListListaOpcionesAction(newNombre),
      });
    }
  });

  return {
    ...query,
    opciones,
  };
}
